import React from 'react'
import {useForm} from 'react-hook-form'
import {usePanelsUpdate, Panels} from 'Event/template/Panels'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import Settings from 'Event/template/Panels/Dashboard/Home/WelcomeTextConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function WelcomeTextConfig(props: ComponentConfigProps) {
  const {showing, onClose} = props
  const {control, register, watch, handleSubmit, formState} = useForm()
  const update = usePanelsUpdate()
  const addTranslation = useAddTranslation()

  const save = (data: Pick<Panels, 'welcomeText' | 'homeMenuTitle'>) => {
    const welcomeText = replaceAtPath(
      data,
      'welcomeText',
      '{{dashboard_home_welcome_text}}',
    )

    const homeMenuTitle = replaceAtPath(
      data,
      'homeMenuTitle',
      '{{dashboard_home_home_menu_title}}',
    )

    update({
      ...data,
      localization: addTranslation({
        dashboard_home_welcome_text: welcomeText ?? 'Welcome!',
        dashboard_home_home_menu_title: homeMenuTitle ?? 'Home',
      }),
    })
    onClose()
  }

  useAutoUpdate({values: watch(), when: showing})

  return (
    <ComponentConfig
      showing={showing}
      onClose={onClose}
      title="Welcome Text"
      onSubmit={handleSubmit(save)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} />
      </SettingsPanel>
      <Footer>
        <SaveButton type="submit" aria-label="save welcome text" />
      </Footer>
    </ComponentConfig>
  )
}
